document.addEventListener("DOMContentLoaded", function () {
  function adjustCollectionContainer(selectedCollection) {
    const isMobile = window.innerWidth <= 768; 
    const brandCollections = document.querySelector(".custom-brand-collections");

    if (!isMobile) return;

    if (selectedCollection) {
      const infoCard = selectedCollection.querySelector(".custom-collection-info-card");

      if (!infoCard) {
        console.log("Mobile: Setting height to 36vh (No InfoCard)");
        brandCollections.style.height = "36vh";
        brandCollections.style.minHeight = "";
      } else {
        console.log("Mobile: Setting height to 60vh (InfoCard Exists)");
        brandCollections.style.height = "60vh";
        brandCollections.style.minHeight = "768px";
      }
    }
  }
  
  function activateFirstCollection() {
    const collections = document.querySelectorAll(".custom-collection-list");
    const brandItems = document.querySelectorAll(".custom-brand-item");

    collections.forEach((collection) => collection.style.display = "none");

    if (brandItems.length > 0) {
      const firstBrand = brandItems[0];
      const firstCollectionId = firstBrand.getAttribute("data-collection");
      const firstCollection = document.getElementById(firstCollectionId);

      if (firstCollection) {
        firstCollection.style.display = "flex";
        firstBrand.classList.add("active");
        adjustProductCardContainer(); 
        adjustCollectionContainer(firstCollection);
      }
    }
  }

  function attachBrandClickEvents() {
    const brandItems = document.querySelectorAll(".custom-brand-item");
    const collections = document.querySelectorAll(".custom-collection-list");

    brandItems.forEach((brand) => {
      brand.removeEventListener("click", handleBrandClick);
      brand.addEventListener("click", handleBrandClick);
    });
  }

  function handleBrandClick() {
    const selectedCollectionId = this.getAttribute("data-collection");
    const collections = document.querySelectorAll(".custom-collection-list");

    collections.forEach((collection) => {
      collection.style.display = "none";
    });

    const activeCollection = document.getElementById(selectedCollectionId);
    if (activeCollection) {
      activeCollection.style.display = "flex";
    }

    const brandItems = document.querySelectorAll(".custom-brand-item");
    brandItems.forEach((item) => item.classList.remove("active"));
    this.classList.add("active");
    adjustProductCardContainer();
    adjustCollectionContainer(activeCollection);
  }

  function adjustProductCardContainer() {
    const sliders = document.querySelectorAll(".custom-collection-slider");
    const isMobile = window.innerWidth <= 768; 
    
    sliders.forEach((slider) => {
      const infoCard = slider.querySelector(".custom-collection-info-card");
      const productContainer = slider.querySelector(".custom-product-card-container");

      if (isMobile) {
        return;
      } else {
        if (!infoCard && productContainer) {
          productContainer.style.flex = "0 0 100%";
        } else if (infoCard && productContainer) {
          productContainer.style.flex = "0 0 50%";
        }
      }
    });
  }

  activateFirstCollection();
  attachBrandClickEvents();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () {
      activateFirstCollection();
      attachBrandClickEvents();
    });

    document.addEventListener("shopify:section:select", function () {
      activateFirstCollection();
      attachBrandClickEvents();
    });
  }

  const observer = new MutationObserver(() => {
    activateFirstCollection();
    attachBrandClickEvents();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".custom-product-card-container");

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("touchstart", (e) => {
      isDown = true;
      startX = e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener("touchmove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.touches[0].pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener("touchend", () => {
      isDown = false;
    });
  });
});